import { useState, useEffect } from 'react'
import { Typography } from '@mui/material'

import { currencyFormatter } from '../utils'

interface PriceProps {
  amount: any
  term?: string
  color?: string
  'data-cy'?: string
}

export const Price = ({
  amount,
  term,
  color = 'primary.500',
  'data-cy': dataCy,
}: PriceProps) => {
  const localeAmount = currencyFormatter(amount)
  const [dollarAmount, setDollarAmount] = useState('')
  const [centAmount, setCentAmount] = useState('')

  useEffect(() => {
    if (localeAmount.includes('.')) {
      setDollarAmount(localeAmount.split('.')[0])
      setCentAmount(localeAmount.split('.')[1])
    } else {
      setDollarAmount(localeAmount)
    }
  }, [localeAmount])

  return (
    <Typography component="p">
      <Typography
        component="span"
        sx={{
          fontSize: '5.2rem',
          fontWeight: 'bold',
          lineHeight: 1,
          color: color,
        }}
        data-cy={dataCy}
      >
        {`${dollarAmount}`}
        {centAmount && centAmount !== '00' && (
          <Typography
            component="span"
            variant="body2XLarge"
            sx={{ fontWeight: 800 }}
          >
            .{centAmount}
          </Typography>
        )}
      </Typography>
      <Typography
        component="span"
        variant="bodySmall"
        sx={{ color: 'primary.400' }}
      >
        {term && `/ ${term}`}
      </Typography>
    </Typography>
  )
}
